















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import SelectOption from "@/interfaces/SelectOption";
import { v4 as uuid } from "uuid";
import NotificationBadge, {
  NotificationBadgeGroups,
} from "@/components/Agents/NotificationBadge.vue";
@Component({
  components: {
    NotificationBadge,
  },
})
export default class VMultiSwitcher extends Vue {
  @Prop() readonly value!: string | number;
  @Prop() readonly items!: Array<SelectOption>;
  @Prop() readonly size?: string;
  @Prop({ default: false }) readonly badge?: boolean;
  @Prop({ default: "buttons" }) readonly variant!: "buttons" | "tabs";

  @Watch("value")
  onValueChange(value: string | number) {
    this.selected = value;
  }

  protected selected: string | number = this.value;

  get isTabs(): boolean {
    return this.variant === "tabs";
  }

  get rootClass(): string {
    return this.isTabs ? "v-multi-switcher-tabs" : "btn-group btn-group-toggle";
  }

  get btnGroupClass() {
    return {
      "btn-group-sm": !this.isTabs && this.size == "sm",
    };
  }

  get showNotificationBadges() {
    return this.badge;
  }

  notificationGroupByItemId(id: string): NotificationBadgeGroups[] {
    const hasNotificationGroup: boolean = Object.values(
      NotificationBadgeGroups
    ).includes(id as NotificationBadgeGroups);

    return hasNotificationGroup ? [id as NotificationBadgeGroups] : [];
  }

  activate(item: SelectOption) {
    if (item.disabled) {
      return;
    }

    this.selected = item.id;
    this.$emit("input", this.selected);
  }

  id(item: SelectOption) {
    return "switcher-" + item.id + uuid();
  }
}
